<ideal-loading-container [loading]="pricingLoading()" class="block">
  <div price-layout>
    <div price-info>
      @if (callForPricing()) {
        <ideal-call-for-price-button call-for-price />
      } @else {
        @if (hasPrice()) {
          <div price main-price>
            @let priceDetails = mainPrice();
            @if (priceDetails.isSale) {
              <div base>{{ priceDetails.priceBase * priceTestFactor | currency }}</div>
            }
            <div current>{{ priceDetails.price * priceTestFactor | currency }}</div>
            <!-- prettier-ignore -->
            <div per i18n="@@product.units.label">
              {priceDetails.pricePer, plural,
              =1 { {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
              other { {{ priceDetails.pricePer | number }} {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
              }
            </div>
          </div>
          @if (hasContainerPrice()) {
            <div divider>
              <div>or</div>
            </div>
            <div price container-price>
              @let priceDetails = containerPrice();
              @if (priceDetails.isSale) {
                <div base>{{ priceDetails.priceBase * priceContainerTestFactor | currency }}</div>
              }
              <div current>{{ priceDetails.price * priceContainerTestFactor | currency }}</div>
              <!-- prettier-ignore -->
              <div per class="indent" i18n="@@product.box-of.label">
          {{ priceDetails.unit }} of {priceDetails.pricePer, plural,
          =1 { {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
          other { {{ priceDetails.pricePer | number }} {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
          }
        </div>
            </div>
          }
        }
      }
    </div>
    @if (isSaleLimited()) {
      <button mat-button limited-time [matMenuTriggerFor]="saleInfo">Limited Time</button>
      <mat-menu #saleInfo="matMenu">
        <div sales-info-popup>
          @let priceData = sale();

          @switch (priceData?.type) {
            @case ("promotion") {
              @let promo = $promo(priceData!);
              <div class="promotion">
                <div class="title">
                  <span>{{ promo.promotionName }}</span>
                </div>
                <div class="starts">
                  <span class="label">Starts</span><span>{{ promo.effectiveDate | date }}</span>
                </div>
                <div class="ends">
                  <span class="label">Ends</span><span>{{ promo.expiryDate | date }}</span>
                </div>
              </div>
            }
            @case ("quote") {
              @let quote = $quote(priceData!);
              <div class="quote">
                <div class="title">
                  <span class="label">Quote #</span><span>{{ quote.quoteNumber }}</span>
                </div>
                <div class="line">
                  <span class="label">Line #</span><span>{{ quote.quoteLine }}</span>
                </div>
                <div class="starts">
                  <span class="label">Starts</span><span>{{ quote.effectiveDate | date }}</span>
                </div>
                <div class="ends">
                  <span class="label">Ends</span><span>{{ quote.expiryDate | date }}</span>
                </div>
              </div>
            }
          }
        </div>
        @switch (priceData?.type) {
          @case ("promotion") {
            @let promo = $promo(priceData!);
            <a mat-menu-item [routerLink]="['/promotions', promo.promotionId]"><div class="label">View Promotion</div></a>
          }
          @case ("quote") {
            @let quote = $quote(priceData!);
            <a mat-menu-item [routerLink]="['/quotes', quote.quoteId]"><div class="label">View Quote</div></a>
          }
        }
      </mat-menu>
    }
  </div>
</ideal-loading-container>
